
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment from "moment";
import httpClient from "@/store/httpClient";
import DatePicker from "@/components/DatePicker.vue";
const Chart = require("chart.js");

@Component({
	components: {
		DatePicker,
	},
})
export default class ReportOrdersProgress extends Vue {
	@Prop()
	private tab!: any;
	private loading: boolean = false;
	private startDate: string = moment().format("YYYY-MM-DD");
	private orderGroups: any[] = [];
	private selectableYears: number[] = [];
	private chart: any = null;
	private headers: any = [
		{
			text: "Zeitraum",
			align: "left",
			sortable: false,
			value: "dateRange",
		},
		{
			text: "Auftragseingang CH [in CHF]",
			align: "right",
			sortable: false,
			value: "amountCHF",
		},
		{
			text: "Auftragseingang DE [in CHF]",
			align: "right",
			sortable: false,
			value: "amountDE",
		},
		{
			text: "Auftragseingang AT [in CHF]",
			align: "right",
			sortable: false,
			value: "amountAT",
		},
		{
			text: "% DE Eingang",
			align: "right",
			sortable: false,
			value: "percentageDE",
		},
		{
			text: "% AT Eingang",
			align: "right",
			sortable: false,
			value: "percentageAT",
		},
		{
			text: "Auftragseingang Total [in CHF]",
			align: "right",
			sortable: false,
			value: "amountTotal",
		},
	];
	private pagination: any = {
		sortBy: "weekNumber",
		descending: false,
		rowsPerPage: -1,
	};
	private selectedComparisonType: any = {};
	private comparisonTypes: any[] = [
		{
			id: 0,
			value: "previousRange",
			text: "Vorgängiger Zeitraum",
		},
		{
			id: 1,
			value: "previousYear",
			text: "Vorige Jahre",
		},
	];
	private selectedNumberOfComparisons: number = 1;
	private numberOfComparisons: number[] = [1, 2, 3, 4, 5];
	private timeRangeGroup: number = 0;
	private timeRangeTypes: any[] = [
		{
			id: 0,
			value: "year",
			text: "Jahr",
		},
		{
			id: 1,
			value: "halfYear",
			text: "Halbjahr",
		},
		{
			id: 2,
			value: "quarter",
			text: "Quartal",
		},
		{
			id: 3,
			value: "month",
			text: "Monat",
		},
	];

	private mounted() {
		this.selectedComparisonType = this.comparisonTypes[0];
	}

	@Watch("selectedComparisonType")
	private onComparisonTypeChange() {
		this.setNumberOfcomparisonSelection();
	}
	@Watch("timeRangeGroup")
	private onTimeRangeChange() {
		this.setNumberOfcomparisonSelection();
	}

	private getFormattedDate(date: Date) {
		return moment(date).format("DD.MM.YYYY");
	}
	private setToday() {
		this.startDate = moment().format("YYYY-MM-DD");
	}

	private async loadOrderReports() {
		if (this.loading) {
			return;
		}
		try {
			this.loading = true;
			const response = await httpClient().get(
				`Report/GetOrderReportPackages?date=${this.startDate}&timeFrame=${this.timeRangeGroup}` +
					`&comparisonType=${this.selectedComparisonType.id}&numberOfComparisons=${this.selectedNumberOfComparisons}`
			);
			this.orderGroups = response.data;
			if (this.orderGroups.length > 0) {
				this.updateDiagram();
			}
		} catch (err) {
			console.log("Loading weekly reports failed.");
			console.log(err);
			this.$store.commit(
				"setSnackbarErrorText",
				"Fehler beim Laden der Reports. Siehe Konsole."
			);
		} finally {
			this.loading = false;
		}
	}

	private updateDiagram() {
		let labels = this.orderGroups.map(
			(o: any) =>
				`${this.getFormattedDate(o.startDate)} - ${this.getFormattedDate(o.endDate)}`
		);

		// Destroy the chart if one already exists.
		if (this.chart != null) {
			this.chart.destroy();
		}

		const ctx = (this.$refs.diagramCanvas as any).getContext("2d");
		this.chart = new Chart(ctx, {
			// The type of chart we want to create
			type: "bar",
			// The data for our dataset
			data: {
				labels,
				datasets: [
					// {
					//     label: 'Total', // Label shown in the legend.
					//     data: this.orderGroups.map((f: any) => f.amountTotal), // Main value of the bars
					//     backgroundColor: 'rgba(239, 187, 32, 0.2)', // Color of the bar filling
					//     borderColor: 'rgb(239, 187, 32)', // Color of the border
					//     borderWidth: 1, // size of border
					// },
					{
						label: "Schweiz", // Label shown in the legend.
						data: this.orderGroups.map((f: any) => f.amountCHF), // Main value of the bars
						backgroundColor: "rgba(239, 187, 32, 0.2)", // Color of the bar filling
						borderColor: "rgb(239, 187, 32)", // Color of the border
						borderWidth: 1, // size of border
						stack: "total",
					},
					{
						label: "Deutschland", // Label shown in the legend.
						data: this.orderGroups.map((f: any) => f.amountDE), // Main value of the bars
						backgroundColor: "rgba(191, 146, 13, 0.2)", // Color of the bar filling
						borderColor: "rgb(191, 146, 13)", // Color of the border
						borderWidth: 1, // size of border
						stack: "total",
					},
					{
						label: "Österreich", // Label shown in the legend.
						data: this.orderGroups.map((f: any) => f.amountAT), // Main value of the bars
						backgroundColor: "rgba(203, 109, 16, 0.2)", // Color of the bar filling
						borderColor: "rgb(203, 109, 16)", // Color of the border
						borderWidth: 1, // size of border
						stack: "total",
					},
				],
			},
			// Configuration options go here
			options: {
				legend: {
					display: true,
				},
				scales: {
					yAxes: [
						{
							ticks: {
								min: 0,
							},
							stacked: true,
						},
					],
				},
				tooltips: {
					callbacks: {
						label: function (tooltipItem: any, data: any): any {
							var money = tooltipItem.yLabel;
							return `${money
								.toFixed(2)
								.toString()
								.replace(/\B(?=(\d{3})+(?!\d))/g, "'")} [in CHF]`;
						},
					},
				},
			},
		});
		this.chart.update();
	}

	private setNumberOfcomparisonSelection() {
		let tempSelection = this.selectedNumberOfComparisons;
		let newNumber = 0;
		if (this.selectedComparisonType.value === "previousYear") {
			newNumber = moment().year() - 2012; // If "Vorjahrsvergleich" always just until 2012
		} else {
			switch (this.timeRangeGroup) {
				case 0: // year
					newNumber = moment().year() - 2012;
					break;
				case 1: // halfyear
					newNumber = (moment().year() - 2012) * 2;
					break;
				case 2: // quarter
					newNumber = (moment().year() - 2011) * 4;
					break;
				case 3: // month
					newNumber = (moment().year() - 2011) * 12;
					break;
			}
		}
		this.numberOfComparisons = [];
		for (let i = 1; i <= newNumber; i++) {
			this.numberOfComparisons[i - 1] = i;
		}
		if (this.numberOfComparisons.includes(tempSelection)) {
			this.selectedNumberOfComparisons = tempSelection;
		} else {
			this.selectedNumberOfComparisons = 1;
		}
	}

	private getPercentage(part: number, total: number) {
		return ((part / total) * 100).toFixed(2);
	}

	private setStartDate(date: Date) {
		this.startDate = moment(date).format("YYYY-MM-DD");
	}
}
